<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="relative bg-white">
    <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
      <div>
        <header>
          <h1 class="launcher-header"
            :class="colorCode == 'bg-light-blue-700' ? 'purple-header' : colorCode == 'bg-pink-400' ? 'orange-header' : 'green-header'">
            <img src="images/logo.png" class="launcher-logo">
            <UserMenu class="launcher-user-menu" />
          </h1>
        </header>
      </div>
      <div class="mt-12 mb-5">
        <img src="images/requestpostlogo.png" width="350px" class="launcher-image" />
        <div class="version">{{ version }}</div>
        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div v-for="feature in features" :key="feature.name" class="pt-6" v-show="feature.auth">
            <div class="flow-root rounded-lg px-6 pb-8 h-full" :class="feature.class" v-if="feature.auth">
              <div class="-mt-6">
                <div>
                  <span class="inline-flex items-center justify-center p-3 rounded-md shadow-lg" :class="feature.iconColor">
                    <Icon :iconName="feature.iconName" :iconType="feature.iconType || 'outline'" :strokeWidth="2"
                      class="h-7 w-7 text-white" />
                  </span>
                </div>
                <h3 class="mt-6 text-lg font-semibold text-gray-900 tracking-tight">{{ feature.name }}</h3>
                <p class="mt-5 text-sm text-gray-500 px-3 text-left whitespace-pre-wrap">
                  {{ feature.description }}
                </p>

                <div class="flex-col mt-4 items-center grid grid-cols-2 px-3">
                  <div v-for="(item, index) in feature.items" :key="item.name" class="flex justify-start"
                    :class="index % 2 != 0 ? 'ml-2' : ''">
                    
                    <template v-if="item.name !== '' && item.auth && !item.etc">
                      <a v-if="item.modal" @click="modalOpen(item.modalName)"
                        class="flex items-center my-1 text-sm font-medium  transition ease-in-out duration-150 cursor-pointer"
                        :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </a>
                      <a v-else-if="item.external" :href="item.url" :target="item.target"
                        class="flex items-center my-1 text-sm font-medium  transition ease-in-out duration-150"
                        :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </a>
                      <router-link v-else :to="item.url"
                        class="flex items-center my-1 text-sm font-medium transition ease-in-out duration-150"
                        :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </router-link>
                    </template>

                    <template v-else-if="item.name !== '' && item.auth && item.initEtc">
                      <div class="px-3" style="text-align: left; margin-top: 0 !important;">
                        <button class="my-1 text-sm font-medium  transition ease-in-out duration-150" @click="showOption(item.initEtc)">
                          {{ optionSw[item.initEtc] ?  '▼' :  '▶' }} その他
                        </button>
                      </div>
                    </template>
                  </div>
                </div>

                <div
                  :class="['flex-col', 'mt-4', 'items-center', 'grid', 'grid-cols-2' , 'px-3', { 'hidden': !optionSw[feature.name] }]"
                  style="margin-top: 0px !important;"
                >
                  <div v-for="(item,index) in feature.items.filter(item => item.etc === true)" :key="item.name"
                    class="flex justify-start"  :class="index % 2 != 0 ? 'ml-2' : ''">
                    <template v-if="item.name !== '' && item.auth">
                      <a v-if="item.modal" @click="modalOpen(item.modalName)"
                        class="flex items-center my-1 text-sm font-medium  transition ease-in-out duration-150 cursor-pointer"
                        :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </a>
                      <a v-else-if="item.external" :href="item.url" :target="item.target"
                        class="flex  my-1 text-sm font-medium  transition ease-in-out duration-150 " :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </a>
                      <router-link v-else :to="item.url"
                        class="flex  my-1 text-sm font-medium transition ease-in-out duration-150" :class="item.class">
                        <Icon :iconName="item.iconName" class="w-4 h-4 mr-1" /> {{ item.name }}
                      </router-link>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 発注マスタ編集 -->
    <EstimatePurchaseModal 
      v-model="purchaseModalShow"
      :purchaseModalShow="purchaseModalShow"
      @closePurchaseModal="closePurchaseModal"
    />
    <!-- 手数料マスタ編集 -->
    <EstimateCommissionModal 
      v-model="commissionModalShow"
      :open="commissionModalShow"
    />
    <!-- 写真報告テンプレート -->
    <TemplateModal 
      v-model="photoReportModalShow"
      :photoReportModalShow="photoReportModalShow"
      menu="photoReport"
      @close="closePhotoReportModal"
    />
    <!-- 環境整備テンプレート -->
    <TemplateModal 
      v-model="envModalShow"
      :photoReportModalShow="envModalShow"
      menu="evaluation"
      @close="closePhotoReportModal"
    />
    <!-- 写真報告書カラー編集 -->
    <PhotoReportColorModal 
      v-model="photoReportColorModalShow"
      :photoReportColorModalShow="photoReportColorModalShow"
      @closePhotoReportColorModal="closePhotoReportColorModal"
    />
    <!-- メアドマスタモーダル -->
    <ClientMailMstModal
      v-model="clientModalShow"
      :open="clientModalShow"
      :selectable="false"
    />
    <!-- 未登録の新規物件報告書（巡回清掃） -->
    <NotRegisteredNewSiteModal
      v-model="notRegisterdModalShow1"
      :open="notRegisterdModalShow1"
      :type="2"
      routerName="RoundCheckListTable"
      :isInfo="true"
      @closed="closeNotRegisterdModal()"
    />
    <!-- 未登録の新規物件報告書（定期清掃） -->
    <NotRegisteredNewSiteModal
      v-model="notRegisterdModalShow2"
      :open="notRegisterdModalShow2"
      :type="3"
      routerName="FixedCheckListTable"
      :isInfo="true"
      @closed="closeNotRegisterdModal()"
    />
    <!-- 写真報告書chatwork設定 -->
    <PhotoReportChatRoomIdModal
      v-model="photoReportChatModalShow1"
      :open="photoReportChatModalShow1"
      menu="photoReport"
    />
    <!-- 環境整備報告書chatwork設定 -->
    <PhotoReportChatRoomIdModal
      v-model="photoReportChatModalShow2"
      :open="photoReportChatModalShow2"
      menu="evaluation"
    />
    <!-- 評価関連chatwork設定 -->
    <EvaluationChatRoomIdModal
      v-model="evaluationChatModalShow"
      :open="evaluationChatModalShow"
      @closed="evaluationChatModalShow=false">
    </EvaluationChatRoomIdModal>
    <!-- 始末書集計 -->
    <EvaluationApologyModal
      v-model="evaluationApologyModalShow"
      :open="evaluationApologyModalShow"
      @closed="evaluationApologyModalShow=false">
    </EvaluationApologyModal>
    <!-- 見積りテスト閲覧権限設定 -->
    <TestDataAuthModal
      v-model="testDataAuthModalShow"
      :open="testDataAuthModalShow"
      @closed="testDataAuthModalShow=false"
    />
    <!-- カレンダー -->
    <CalendarModal
      v-model="calendarModalShow"
      :open="calendarModalShow"
      @closed="calendarModalShow=false"
    />
    <!-- 巡回関連chatwork設定 -->
    <PatrolChatRoomIdModal
      v-model="patrolChatModalShow"
      :open="patrolChatModalShow"
      @closed="patrolChatModalShow=false"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import { PIGEON_CONFIG } from '@/config'
import UserMenu from '@components/UserMenu.vue'
import EstimatePurchaseModal from '../../Estimation/components/EstimatePurchaseModal.vue'
import EstimateCommissionModal from '../../Estimation/components/EstimateCommissionModal.vue'
import TemplateModal from '../../PhotoReport/components/TemplateModal.vue'
import PhotoReportColorModal from '../../PhotoReport/components/PhotoReportColorModal.vue'
import ClientMailMstModal from '../../Master/components/ClientMailMstModal.vue'
import NotRegisteredNewSiteModal from '../../FixedClean/components/NotRegisteredNewSiteModal.vue'
import PhotoReportChatRoomIdModal from '../../Master/components/PhotoReportChatRoomIdModal.vue'
import EvaluationChatRoomIdModal from '../../Evaluation/components/EvaluationChatRoomIdModal.vue'
import EvaluationApologyModal from '../../Evaluation/components/EvaluationApologyModal.vue'
import TestDataAuthModal from '../../Estimation/components/TestDataAuthModal.vue'
import CalendarModal from '../../Patrol/components/CalendarModal.vue'
import PatrolChatRoomIdModal from '../../Master/components/PatrolChatRoomIdModal.vue'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import PageModel from './PageModel.vue'

export default {
  extends: PageModel,
  components: {
    Icon,
    UserMenu,
    EstimatePurchaseModal,
    EstimateCommissionModal,
    TemplateModal,
    PhotoReportColorModal,
    ClientMailMstModal,
    NotRegisteredNewSiteModal,
    PhotoReportChatRoomIdModal,
    EvaluationChatRoomIdModal,
    EvaluationApologyModal,
    TestDataAuthModal,
    CalendarModal,
    PatrolChatRoomIdModal
  },

  mounted() {
  },

  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    },
  },

  methods: {
    showOption(i) {
      this.optionSw[i] = !this.optionSw[i]
    },

    /**
     * モーダルopen
     */
    async modalOpen(target) {
      if (target && target.indexOf('Dialogs') > -1) {
        if (target.indexOf('interviews') > -1) {
          const res = await dialogs.showConfirmDialog3('当てはまるものを選択してください', '', '清掃員', '中途社員', '新卒社員')
          this.$router.push({ name: 'RequestPost', query: { interviews: res }})
        }
      } else {
        this[target] = true
      }
    },

    /**
     * モーダルclose
     */
    closePurchaseModal() {
      this.purchaseModalShow = false
    },

    /**
     * 写真報告テンプレートモーダルclose
     */
    closePhotoReportModal() {
      this.photoReportModalShow = false
      this.envModalShow = false
    },

    /**
     * 写真報告書カラー モーダルclose
     */
    closePhotoReportColorModal() {
      this.photoReportColorModalShow = false
    },

    /**
     * 定期清掃未登録物件モーダルclose
     */
    closeNotRegisterdModal() {
      this.notRegisterdModalShow1 = false
      this.notRegisterdModalShow2 = false
    }
    
  },

  async created() {
    this.version = 'ver: ' + this.$store.getters.appVersion.trim()
    // バージョン取得
    let retVar = await backend.searchData('param', { key: 'version' })
    if (retVar.data.data && retVar.data.data.length > 0) {
      this.versionDB = retVar.data.data[0].parameterValue
    }

    let auth = this.$store.getters.auth
    if (auth && auth.adminAuth) {
      this.adminAuth = true
    }
    if (auth && auth.userAuth) {
      this.userAuth = true
    }
    if (auth && auth.mainAuth) {
      this.mainAuth = true
    }
    if (auth && auth.subAuth) {
      this.subAuth = true
    }
    if (auth && auth.estimateAuth) {
      this.estimateAuth = true
    }
    if (auth && auth.patrolAuth) {
      this.patrolAuth = true
    }
    if (auth && auth.roundCleanAuth) {
      this.roundCleanAuth = true
    }
    if (auth && auth.fixedCleanAuth) {
      this.fixedCleanAuth = true
    }
    if (auth && auth.facilityPatrolAuth) {
      this.facilityPatrolAuth = true
    }
    if (auth && auth.photoReportAuth) {
      this.photoReportAuth = true
    }
    if (auth && auth.rlsAuth) {
      this.rlsAuth = true
    }
    if (auth && auth.evaluationAuth) {
      this.evaluationAuth = true
    }
    if (auth && auth.bonusAuth) {
      this.bonusAuth = true
    }
    if (auth && auth.contractAuth) {
      this.contractAuth = true
    }
    if (auth && auth.regularStaffAuth) {
      this.regularStaffAuth = true
    }
    if (auth && auth.akbsMenuAuth) {
      this.akbsMenuAuth = true
    }
    if (auth && auth.qualityReportAuth) {
      this.qualityReportAuth = true
    }
    if (auth && auth.partTimer) {
      this.partTimer = true
    }
    
    const dep = this.$store.getters.dualPosition
    if (dep && dep.length) {
      // 人事部か確認
      const isDep = dep.find((d) => {
        return d.departmentName && d.departmentName.indexOf('人事') > -1
      })
      if (isDep && isDep.departmentName) {
        this.hrd = true
      }
    }

    this.features = [
      {
        name: 'メインタスク',
        description: 'メインタスクを登録・管理します。',
        iconName: 'UserGroup',
        iconColor: 'bg-pink-600',
        auth: this.mainAuth,
        class: 'bg-red-50',
        items: [
          {
            name: '新規登録',
            url: `./RequestPost`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.mainAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '一覧',
            url: `./RequestPostList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.mainAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '雇い入れ集計',
            url: `./EmploymentList`,
            iconName: 'ChartSquareBar',
            external: true,
            etc: true,
            initEtc: 'メインタスク',
            auth: this.mainAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '得意先メールマスタ',
            url: `./`,
            iconName: 'Terminal',
            external: true,
            etc: true,
            auth: this.mainAuth,
            modal: true,
            modalName: 'clientModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: 'サブタスク',
        description: 'メインで発生するサブタスクを登録・管理します。',
        iconName: 'Share',
        iconColor: 'bg-pink-600',
        auth: this.subAuth,
        class: 'bg-red-50',
        items: [
          {
            name: '進捗一覧',
            url: `./RequestPostProgressList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.subAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'カレンダー',
            url: `./TaskCalendar`,
            iconName: 'Calendar',
            external: true,
            auth: this.subAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '見積書',
        description: '見積書の作成・管理します。',
        iconName: 'CurrencyYen',
        iconColor: 'bg-pink-600',
        auth: this.estimateAuth,
        class: 'bg-red-50',
        items: [
          {
            name: '承認待ち一覧',
            url: `./EstimateList?tabId=awaitingApproval`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '一覧',
            url: `./EstimateList?tabId=all`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'ﾒｲﾝﾀｽｸ未完了一覧',
            url: `./EstimateList?tabId=incomplete`,
            iconName: 'ClipboardList',
            external: true,
            etc: true,
            initEtc: '見積書',
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '受注一覧',
            url: `./EstimateList?tabId=ordered`,
            iconName: 'ClipboardList',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '見積集計',
            url: `./EstimateChart`,
            iconName: 'ChartSquareBar',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '見積り単価',
            url: `./EstimatePriceMaster`,
            iconName: 'CurrencyYen',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // ラウンドプラスの種別ごとにお客様宛メールへ初期値で付ける PDF（追加・削除は管理者だけ。見るのは見積権限）
            name: '固定添付ﾏｽﾀ',
            url: `./EstimateFixedAttachmentMaster`,
            iconName: 'PaperClip',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'ﾃｽﾄﾃﾞｰﾀ表示',
            url: `./`,
            iconName: 'Terminal',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            modal: true,
            modalName: 'testDataAuthModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '得意先ﾒｰﾙﾏｽﾀ',
            url: `./`,
            iconName: 'Terminal',
            external: true,
            etc: true,
            auth: this.estimateAuth,
            modal: true,
            modalName: 'clientModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        // 見られるのは「AKBS関連メニュー」権限（mst_auth.akbs_menu_auth）のある人だけ（サブタスク権限ではない）
        name: 'AKBS関連',
        description: 'AKBSに関連するデータを更新・管理します。',
        iconName: 'Share',
        iconColor: 'bg-pink-600',
        auth: this.akbsMenuAuth,
        class: 'bg-red-50',
        items: [
          {
            name: '申請一覧',
            url: `./AkbsPendingList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.akbsMenuAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // 本番のAKBSに登録されている清掃員・家族・緊急連絡先・雇用指示・賃金・契約詳細を見る（清掃員の一部と書類は直せる）
            name: '登録済み一覧',
            url: `./AkbsRegisteredList`,
            iconName: 'FolderOpen',
            external: true,
            auth: this.akbsMenuAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // 清掃員へ送る書類・業務報告書などをまとめて出す（書類設定もこの中）
            name: '出力',
            url: `./AkbsOutput`,
            iconName: 'Download',
            external: true,
            auth: this.akbsMenuAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // 最低賃金マスタの設定と、賃金の一括変更（変更できるのは人事総務経理に所属している人か管理者権限のある人）
            name: '賃金',
            url: `./AkbsWage`,
            iconName: 'CurrencyYen',
            external: true,
            auth: this.akbsMenuAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          // {
          //   name: 'カレンダー',
          //   url: `./TaskCalendar`,
          //   iconName: 'Calendar',
          //   external: true,
          //   auth: this.subAuth,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
        ]
      },
      {
        name: '巡回清掃',
        description: '巡回清掃の設定・状況を表示します。',
        iconName: 'Sparkles',
        iconColor: 'bg-blue-600',
        auth: this.roundCleanAuth,
        class: 'bg-blue-50',
        items: [
          {
            name: '未点検一覧',
            url: `./RoundUnPatrolList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.roundCleanAuth,
            class: 'pink text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '予定一覧',
            url: `./RoundScheduleListByStaff`,
            iconName: 'Calendar',
            external: true,
            auth: this.roundCleanAuth,
            class: 'light-green text-indigo-600 hover:text-indigo-500'
          },
          // {
          //   name: '点検項目設定',
          //   url: `./PatrolInspection`,
          //   iconName: 'PencilAlt',
          //   external: true,
          //   auth: this.roundCleanAuth,
          //   etc: true,
          //   initEtc: true,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
          // ↓この条件は使用しなくなったが、他で使う可能性があるため、残す
          // {
          //   name: '対象物件マスタ',
          //   url: `./RoundSiteListMaster`,
          //   iconName: 'PencilAlt',
          //   external: true,
          //   auth: this.roundCleanAuth,
          //   initEtc: '巡回清掃',
          //   etc: true,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
          {
            name: '報告書項目設定',
            url: `./RoundPatrolInspection`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.roundCleanAuth,
            etc: true,
            initEtc: '巡回清掃',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '施工月設定',
            url: `./RoundTerm`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.roundCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '未登録の物件',
            url: `./`,
            iconName: 'DocumentDownload',
            external: true,
            etc: true,
            auth: this.roundCleanAuth,
            modal: true,
            modalName: 'notRegisterdModalShow1',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '作業完了一覧',
            url: `./RoundCheckList`,
            iconName: 'ClipboardCheck',
            external: true,
            auth: this.roundCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'ダウンロード',
            url: `./RoundDownload`,
            iconName: 'Download',
            external: true,
            auth: this.roundCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '定期清掃',
        description: '定期清掃の設定・状況を表示します。',
        iconName: 'Sparkles',
        iconColor: 'bg-blue-600',
        auth: this.fixedCleanAuth,
        class: 'bg-blue-50',
        items: [
          {
            name: '未完了一覧',
            url: `./FixedUnPatrolList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.fixedCleanAuth,
            class: 'pink text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '予定一覧',
            url: `./FixedScheduleListByStaff`,
            iconName: 'Calendar',
            external: true,
            auth: this.fixedCleanAuth,
            class: 'light-green text-indigo-600 hover:text-indigo-500'
          },
          // {
          //   name: '報告書項目設定',
          //   url: `./FixedPatrolInspection`,
          //   iconName: 'PencilAlt',
          //   external: true,
          //   auth: this.fixedCleanAuth,
          //   initEtc: '定期清掃',
          //   etc: true,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
          {
            name: '施工月・項目設定',
            url: `./FixedPatrolTerm`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.fixedCleanAuth,
            initEtc: '定期清掃',
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '棟設定',
            url: `./FixedRidge`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.fixedCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '未登録の物件',
            url: `./`,
            iconName: 'DocumentDownload',
            external: true,
            etc: true,
            auth: this.fixedCleanAuth,
            modal: true,
            modalName: 'notRegisterdModalShow2',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '貼紙・完了報告',
            url: `./FixedPoster`,
            iconName: 'Archive',
            external: true,
            auth: this.fixedCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '作業完了一覧',
            url: `./FixedCheckList`,
            iconName: 'ClipboardCheck',
            external: true,
            auth: this.fixedCleanAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: 'RLS',
        description: 'RLSの予定・結果を表示します。',
        iconName: 'Sparkles',
        iconColor: 'bg-blue-600',
        auth: this.rlsAuth,
        class: 'bg-blue-50',
        items: [
          {
            name: 'RLS実施',
            url: `./RlsForm`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.rlsAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '予定・結果',
            url: `./RlsOperation`,
            iconName: 'Calendar',
            external: true,
            auth: this.rlsAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'RLSマスタ',
            url: `./RlsMaster`,
            iconName: 'Cog',
            external: true,
            auth: this.rlsAuth,
            initEtc: 'RLS',
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          }
          // {
          //   name: '実績一覧',
          //   url: `./RlsList`,
          //   iconName: 'ClipboardList',
          //   external: true,
          //   auth: this.rlsAuth,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
          // {
          //   name: 'RLS集計',
          //   url: `./RlsCounting`,
          //   iconName: 'ChartSquareBar',
          //   external: true,
          //   auth: this.rlsAuth,
          //   initEtc: 'RLS',
          //   etc: true,
          //   class: 'text-indigo-600 hover:text-indigo-500'
          // },
        ]
      },
      {
        name: '面接関連',
        description: '面接タスクを登録・集計します。',
        iconName: 'UserAdd',
        iconColor: 'bg-purple-500',
        auth: this.mainAuth,
        class: 'bg-purple-100',
        items: [
          {
            name: '新規登録',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.mainAuth,
            modal: true,
            modalName: 'interviewsDialogs',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '面接一覧',
            url: `./InterviewsList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.mainAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '新卒集計',
            url: `./NewGradList`,
            iconName: 'ChartSquareBar',
            external: true,
            // etc: true,
            auth: this.mainAuth&&this.regularStaffAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '評価・教育関連',
        description: '評価から賞与まで全てを管理します。',
        iconName: 'BookmarkAlt',
        iconColor: 'bg-purple-500',
        auth: this.evaluationAuth,
        class: 'bg-purple-100',
        items: [
          {
            name: '自己評価',
            url: `./EvaluationInput`,
            iconName: 'User',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '上司評価',
            url: `./EvaluationList`,
            iconName: 'Users',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '環境整備',
            url: `./`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.evaluationAuth,
            modal: true,
            modalName: 'envModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '勉強会',
            url: `./StudyPolicy`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '日報',
            url: `./DailyReport`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '同行',
            url: `./Accompany`,
            iconName: 'UserCircle',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '気づき感想文',
            url: `./StampTable`,
            iconName: 'CheckCircle',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '賞与面談',
            url: `./BonusList`,
            iconName: 'CurrencyYen',
            external: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '環境整備一覧',
            url: `./EnvReportList`,
            iconName: 'ClipboardList',
            external: true,
            initEtc: '評価・教育関連',
            etc: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '勉強会一覧',
            url: `./StudyPolicyList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.evaluationAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '日報一覧',
            url: `./DailyReportList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.evaluationAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '環境整備集計',
            url: `./EnvReportCounting`,
            iconName: 'ChartSquareBar',
            external: true,
            etc: true,
            auth: this.evaluationAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '環境整備項目設定',
            url: `./EnvReportItemSetting`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.evaluationAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '組織図',
            url: `./Organization`,
            iconName: 'Share',
            external: true,
            auth: this.evaluationAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '勉強会動画設定',
            url: `./EvaluationMovieMaster`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.hrd||this.adminAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '入力制限解除',
            url: `./UnlockSetting`,
            iconName: 'LockOpen',
            external: true,
            auth: this.hrd||this.adminAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'Chatwork設定',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.hrd||this.adminAuth,
            modal: true,
            modalName: 'evaluationChatModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'インポート',
            url: `./EvaluationImport`,
            iconName: 'FolderDownload',
            external: true,
            etc: true,
            auth: this.hrd||this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '始末書集計',
            url: `./`,
            iconName: 'DocumentRemove',
            external: true,
            etc: true,
            auth: this.bonusAuth||this.adminAuth,
            modal: true,
            modalName: 'evaluationApologyModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '賞与設定',
            url: `./Bonus`,
            iconName: 'CurrencyYen',
            external: true,
            etc: true,
            auth: this.bonusAuth||this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '上司入力平均',
            url: `./BossAverage`,
            iconName: 'TrendingUp',
            external: true,
            auth: this.adminAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '写真報告書',
        description: '提案書・現地調査を作成します。',
        iconName: 'Camera',
        iconColor: 'bg-green-600',
        auth: this.photoReportAuth,
        class: 'bg-green-50',
        items: [
          {
            name: '新規作成',
            url: `./`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.photoReportAuth,
            modal: true,
            modalName: 'photoReportModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '一覧',
            url: `./PhotoReportList`,
            iconName: 'Calendar',
            external: true,
            auth: this.photoReportAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '項目設定',
            url: `./PhotoReportItemSetting`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.photoReportAuth,
            initEtc: '写真報告書',
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '配色設定',
            url: `./`,
            iconName: 'ColorSwatch',
            external: true,
            etc: true,
            auth: this.photoReportAuth,
            modal: true,
            modalName: 'photoReportColorModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '品質巡回',
        description: '品質巡回の設定・状況を表示します。',
        iconName: 'ClipboardCheck',
        auth: this.patrolAuth,
        iconColor: 'bg-green-600',
        class: 'bg-green-50',
        items: [
          {
            name: '未点検一覧',
            url: `./UnPatrolList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.patrolAuth,
            class: 'pink text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '予定一覧',
            url: `./ScheduleListByStaff`,
            iconName: 'Calendar',
            external: true,
            auth: this.patrolAuth,
            class: 'light-green text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '点検項目設定',
            url: `./PatrolInspection`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            initEtc: '品質巡回',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '確認項目設定',
            url: `./PatrolCheckItemMaster`,
            iconName: 'CheckCircle',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '点検サイクル設定',
            url: `./PatrolTerm`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '点検一覧',
            url: `./CheckList`,
            iconName: 'ClipboardCheck',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'ダウンロード',
            url: `./Download`,
            iconName: 'Download',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '得意先毎の未点検',
            url: `./CountUnPatrolByClient`,
            iconName: 'DocumentRemove',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'クレーム未点検',
            url: `./ClaimUnPatrolList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'クレーム点検一覧',
            url: `./ClaimCheckList`,
            iconName: 'ClipboardCheck',
            external: true,
            auth: this.patrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '設備点検',
        description: '設備点検の設定・状況を表示します。',
        iconName: 'ClipboardCheck',
        iconColor: 'bg-green-600',
        auth: this.facilityPatrolAuth,
        class: 'bg-green-50',
        items: [
          {
            name: '未点検一覧',
            url: `./FacilityUnPatrolList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.facilityPatrolAuth,
            class: 'pink text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '予定一覧',
            url: `./FacilityScheduleListByStaff`,
            iconName: 'Calendar',
            external: true,
            auth: this.facilityPatrolAuth,
            class: 'light-green text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '項目・ｻｲｸﾙ設定',
            url: `./FacilityTerm`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.facilityPatrolAuth,
            initEtc: '設備点検',
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'チーム名設定',
            url: `./FacilityTeamNameMaster`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.facilityPatrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '点検一覧',
            url: `./FacilityCheckList`,
            iconName: 'ClipboardCheck',
            external: true,
            auth: this.facilityPatrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'GoogleDrive',
            url: `./FacilityDownload`,
            iconName: 'Download',
            external: true,
            auth: this.facilityPatrolAuth,
            etc: true,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        // 物件の点検・撮影 → PDF。並びは RLS と同じ（実施・予定・結果・マスタ）
        name: 'クオリティレポート',
        description: 'クオリティレポートの実施・予定・結果を表示します。',
        iconName: 'Camera',
        iconColor: 'bg-green-600',
        auth: this.qualityReportAuth,
        class: 'bg-green-50',
        items: [
          {
            // 実施＝作業員向けのカード一覧（最初は自分の担当。「実施する」から報告書画面へ）
            name: '実施',
            url: `./QualityReportMine`,
            iconName: 'Camera',
            external: true,
            auth: this.qualityReportAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // 進捗＝月ごとの予定日・担当者（マスタから自動。手で直せる）と結果、スタッフごと＝担当者ごとの件数
            name: '予定・結果',
            url: `./QualityReportSchedule`,
            iconName: 'Calendar',
            external: true,
            auth: this.qualityReportAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            // 対象物件（作業明細から自動）と、物件ごとの契約枚数・実施日・撮影する箇所
            name: 'マスタ',
            url: `./QualityReportSiteSetting`,
            iconName: 'Cog',
            external: true,
            auth: this.qualityReportAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: '契約情報',
        description: '契約情報を登録・管理します。',
        iconName: 'InformationCircle',
        iconColor: 'bg-yellow-600',
        auth: this.contractAuth,
        class: 'bg-yellow-50',
        items: [
          {
            name: 'MAP',
            url: `./ContractMap`,
            iconName: 'GlobeAlt',
            external: true,
            auth: this.contractAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '物件概要書',
            url: `./SiteOutline`,
            iconName: 'OfficeBuilding',
            external: true,
            auth: this.contractAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          }
        ]
      },
      {
        name: 'マスタメンテナンス',
        description: 'マスタデータのメンテナンスを行います。',
        iconName: 'Database',
        iconColor: 'bg-yellow-600',
        auth: (this.adminAuth || this.userAuth),
        class: 'bg-yellow-50',
        items: [
          {
            name: 'サブタスク',
            url: `./SubTaskMaster`,
            iconName: 'PencilAlt',
            external: true,
            target: '_blank',
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'タスク依頼セット',
            url: `./SubTaskSetMaster`,
            iconName: 'PencilAlt',
            external: true,
            target: '_blank',
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '日常・管理エリア',
            url: `${PIGEON_CONFIG.baseUrl}form?formId=eria_normal_management_master`,
            iconName: 'PencilAlt',
            external: true,
            target: '_blank',
            etc: true,
            initEtc: 'マスタメンテナンス',
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '定期清掃エリア',
            url: `${PIGEON_CONFIG.baseUrl}form?formId=eria_fixed_master`,
            iconName: 'PencilAlt',
            external: true,
            target: '_blank',
            etc: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '承認ルート',
            url: `./EstimateApprovalMaster`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '承認Chatwork',
            url: `${PIGEON_CONFIG.baseUrl}form?formId=estimate_approver_chatwork_master`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            target: '_blank',
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: 'ユーザー設定',
            url: `./UserMaster`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: (this.adminAuth || this.userAuth),
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '部署設定',
            url: `./DepartmentMaster`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '巡回関連スタッフ',
            url: `./PatrolStaffMaster`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '発注先マスタ',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            modal: true,
            modalName: 'purchaseModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '手数料マスタ',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            modal: true,
            modalName: 'commissionModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '作業内容マスタ',
            url: `./estimateWorkCodeMaster`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '写真報告Chatwork',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            modal: true,
            modalName: 'photoReportChatModalShow1',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '環境整備Chatwork',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            modal: true,
            modalName: 'photoReportChatModalShow2',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
          {
            name: '巡回関連Chatwork',
            url: `./`,
            iconName: 'PencilAlt',
            external: true,
            etc: true,
            auth: this.adminAuth,
            modal: true,
            modalName: 'patrolChatModalShow',
            class: 'text-indigo-600 hover:text-indigo-500'
          },
        ]
      },
      {
        name: 'ログ',
        description: '操作ログを確認いただけます。',
        iconName: 'Database',
        iconColor: 'bg-yellow-600',
        auth: this.adminAuth,
        class: 'bg-yellow-50',
        items: [
          {
            name: 'ログ一覧',
            url: `./LogList`,
            iconName: 'ClipboardList',
            external: true,
            auth: this.adminAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          }
        ]
      },
    ]

    // 管理者権限がなく、ユーザー設定権限がある場合
    if (!this.adminAuth && this.userAuth) {
      for (let i = 0; i < this.features.length; i++) {
        const f = this.features[i]
        
        if (f.name == 'マスタメンテナンス') {
          // ユーザー設定を削除
          f.items.splice(6, 1)
          // ユーザー設定を先頭にする
          f.items.unshift({
            name: 'ユーザー設定',
            url: `./UserMaster`,
            iconName: 'PencilAlt',
            external: true,
            auth: this.userAuth,
            class: 'text-indigo-600 hover:text-indigo-500'
          },)
          break
        }
      }
    }

    // パートさんの場合
    if (this.partTimer) {
      let name = ['品質巡回', '巡回清掃', '定期清掃', '設備点検', '写真報告書', '評価・教育関連']
      for (let i = 0; i < this.features.length; i++) {
        const f = this.features[i]
        
        if (name.includes(f.name)) {
          f.items.splice(0, 1)
          f.items.splice(1, f.items.length)
          break
        }
      }
    }

    // キャッシュチェック
    if (this.versionDB != this.$store.getters.appVersion.trim()) alert('古いページを開いています。ブラウザを閉じて開き直してください。')

    // セッションストレージを空にする（メイン一覧）
    sessionStorage.removeItem('requestPostListText')
    sessionStorage.removeItem('requestPostListLast')
    // セッションストレージを空にする（進捗一覧）
    sessionStorage.removeItem('subListText')
    sessionStorage.removeItem('subListLast')
    // セッションストレージを空にする（見積一覧）
    sessionStorage.removeItem('estimateListConditionReset')
  },

  data() {
    return {
      features: [],
      // 管理者権限
      adminAuth: false,
      // ユーザー設定
      userAuth: false,
      // メインタスク権限
      mainAuth: false,
      // サブタスク権限
      subAuth: false,
      // AKBS関連メニュー権限（申請一覧・登録済み一覧・出力・賃金）
      akbsMenuAuth: false,
      // 見積もり権限
      estimateAuth: false,
      // 品質巡回権限
      patrolAuth: false,
      // 巡回清掃権限
      roundCleanAuth: false,
      // 定期清掃権限
      fixedCleanAuth: false,
      // 設備点検権限
      facilityPatrolAuth: false,
      // 写真報告権限
      photoReportAuth: false,
      // RLS権限
      rlsAuth: false,
      // クオリティレポート権限
      qualityReportAuth: false,
      // 評価シート権限
      evaluationAuth: false,
      // 賞与画面 権限
      bonusAuth: false,
      // 面接 権限
      regularStaffAuth: false,
      // 人事部
      hrd: false,
      // パート
      partTimer: false,
      // ヘッダカラー
      colorCode: PIGEON_CONFIG.colorCode,
      // バージョン（package)
      version: '',
      // バージョン（DB)
      versionDB: '',
      // その他スイッチ
      optionSw: { 'メインタスク': false, '見積書': false, '品質巡回': false, '巡回清掃': false, '定期清掃': false, '設備点検': false, '写真報告書': false, 'マスタメンテナンス': false, '評価・教育関連': false, 'RLS': false},

      // 発注先モーダル開閉
      purchaseModalShow: false,
      // 手数料モーダル開閉
      commissionModalShow: false,
      // 写真報告選択モーダル開閉
      photoReportModalShow: false,
      // 環境整備選択モーダル開閉
      envModalShow: false,
      // 写真報告書カラーモーダル開閉
      photoReportColorModalShow: false,
      // 得意先メアドモーダル開閉
      clientModalShow: false,
      // 未登録物件（巡回清掃）
      notRegisterdModalShow1: false,
      // 未登録物件（定期清掃）
      notRegisterdModalShow2: false,
      // 写真報告書chatworkモーダル開閉
      photoReportChatModalShow1: false,
      // 環境整備chatworkモーダル開閉
      photoReportChatModalShow2: false,
      // 日報chatworkモーダル開閉
      evaluationChatModalShow: false,
      // 始末書集計モーダル開閉
      evaluationApologyModalShow: false,
      // 見積りテスト権限モーダル開閉
      testDataAuthModalShow: false,
      // カレンダーモーダル開閉
      calendarModalShow: false,
      // 巡回関連chatworkモーダル開閉
      patrolChatModalShow: false
    }
  }
}
</script>
<style scoped>
.light-green {
  /* color: #71ad73; */
  background: rgb(210, 231, 210);
  width: 100%;
}

.pink {
  /* color: #dd1a83; */
  background: rgb(245 208 208 / 75%);
  width: 100%;
}

.copy:first-letter {
  color: red;
}

.version {
  position: absolute;
  top: 170px;
  left: 60%;
  color: lightslategray;
  font-size: small;
}
</style>